<template>
  <div class="flex items-center gap-2">
    <!-- Webpro Emblem -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 105 103.667"
      class="h-full w-auto"
      aria-hidden="true"
    >
      <g>
        <path
          fill="#D40050"
          d="M20.545,20.328L6.165,30.98c-0.394,0.292-0.67,0.927-0.613,1.412l0.847,7.4L20.545,20.328z"
        />
        <path
          fill="#D40050"
          d="M63.813,8.523L47.397,1.395C46.949,1.2,46.26,1.279,45.869,1.57l-5.986,4.434L63.813,8.523z"
        />
        <path
          fill="#D40050"
          d="M95.67,40.094l-2.035-17.783c-0.056-0.485-0.468-1.042-0.916-1.237l-6.834-2.967L95.67,40.094z"
        />
        <path
          fill="#D40050"
          d="M84.259,83.464l14.382-10.651c0.394-0.291,0.668-0.927,0.612-1.412L98.407,64L84.259,83.464z"
        />
        <path
          fill="#D40050"
          d="M40.992,95.271l16.416,7.128c0.447,0.194,1.137,0.115,1.527-0.176l5.985-4.435L40.992,95.271z"
        />
        <path
          fill="#D40050"
          d="M9.135,63.703l2.035,17.78c0.056,0.485,0.467,1.042,0.917,1.235l6.831,2.968L9.135,63.703z"
        />
      </g>
      <polygon
        fill="#892324"
        points="63.813,8.523 39.883,6.003 20.545,20.328 6.398,39.792 9.135,63.703 18.917,85.686 40.992,95.271 64.921,97.789 84.259,83.464 98.407,64 95.67,40.094 85.885,18.106"
      />
      <g>
        <path
          fill="#97BF0D"
          d="M72.331,98.569c0.485,0.052,1.119-0.231,1.405-0.626l10.522-14.479L64.921,97.789L72.331,98.569z"
        />
        <path
          fill="#97BF0D"
          d="M102.947,56.444l-7.276-16.35L98.407,64l4.379-6.024C103.072,57.58,103.145,56.891,102.947,56.444z"
        />
        <path
          fill="#97BF0D"
          d="M32.474,5.224c-0.486-0.051-1.119,0.231-1.406,0.626L20.545,20.328L39.883,6.003L32.474,5.224z"
        />
        <path
          fill="#97BF0D"
          d="M21.947,92.492c0.198,0.445,0.759,0.854,1.245,0.904l17.8,1.874l-22.074-9.585L21.947,92.492z"
        />
        <path
          fill="#97BF0D"
          d="M82.857,11.302c-0.198-0.447-0.76-0.854-1.246-0.905L63.813,8.523l22.072,9.583L82.857,11.302z"
        />
        <path
          fill="#97BF0D"
          d="M2.018,45.819c-0.287,0.396-0.359,1.084-0.161,1.531l7.278,16.353l-2.737-23.91L2.018,45.819z"
        />
      </g>
      <path
        fill="#F2F2F2"
        d="M30.179,70.8V28.485h8.823V70.8H30.179z M39.002,77.853V70.8h8.824v7.053H39.002z M47.827,70.8V49.643h8.823V70.8H47.827z M56.65,77.853V70.8h8.822v7.053H56.65z M65.473,70.8V28.485h8.823V70.8H65.473z"
      />
    </svg>

    <!-- Wortmarke -->
    <span class="text-highlighted font-semibold text-lg">Web </span><span class="text-primary font-semibold text-lg">Professionals</span>
  </div>
</template>
